<div class="block__right-side-panel">
    <div class="block-full-width no-padding no-border-radius">
        <div class="card-details">
            <div class="card-details-area">

                <h2 class="card-details-area__title margin-bottom-10">
                    {{'ISIC_CARD_ACTIVATION_FORM_TITLE' | translate}}</h2>
                <p class="required-text">{{'REQUIRED_FIELDS_FORM_TITLE' | translate}}</p>

                <form ridangoFocusInvalidInput [formGroup]="_isicCardActivationForm" (ngSubmit)="submitForm()">
                    <div class="card-details-area__card-number">
                        <ridango-form-field class="form-margin-10">
                            <input ridangoInput [formControl]="_isicCardActivationForm.controls.personal_code"
                                name="travelcard.personal_code" required>
                            <ridango-label>{{'PH_PERSONAL_CODE' | translate}}</ridango-label>

                            <ridango-error *ngIf="_isicCardActivationForm.controls.personal_code.hasError('required')">
                                {{'FIELD_VALIDATION_REQUIRED' | translate}}
                            </ridango-error>

                            <ridango-error *ngIf="_isicCardActivationForm.controls.personal_code.hasError('pattern')">
                                {{'FIELD_VALIDATION_PERSONAL_NUMBER_INVALID_FORMAT' | translate}}
                            </ridango-error>

                            <ridango-error *ngIf="_isicCardActivationForm.controls.personal_code.hasError('personalCode')">
                                {{'LOCAL_PERSONALIZATION_PERSONAL_CODE_WRONG_FORMAT_ERROR' | translate}}
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="item-tnc">
                        <span class="checkbox-wcag">
                            <input type="checkbox" attr.aria-hidden="true" class="checkbox-wcag__checkbox"
                                formControlName="terms" required tabindex="-1"
                                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}" />

                            <span class="checkbox-wcag__checkmark" tabindex="0" (click)="toggleCheckbox()"
                                (keydown.space)="toggleCheckbox()" attr.aria-checked="{{ termsAgreed }}" role="checkbox"
                                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}">
                            </span>

                            <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                                <span>
                                    <span class="link-label" (click)="toggleCheckbox()"
                                        (keydown.enter)="toggleCheckbox()" (keydown.space)="toggleCheckbox()">
                                        {{ 'READ_ISIC_CARD_TERMS' | translate }}
                                    </span>

                                </span>
                            </label>
                        </span>
                    </div>

                    <button class="btn btn--maximal btn--primary btn--big" type="submit"
                        [disabled]="_isicCardActivationForm.invalid"
                        *ngIf="!(isicCardActivationLoading$ | async)">{{'BTN_ACTIVATE_ISIC' | translate}}</button>

                    <button class="btn btn--maximal btn--big btn--primary" *ngIf="isicCardActivationLoading$ | async"
                        disabled>
                        <span class="btn-loader">
                            <span>
                                <span class="btn-loader__img"><img src="assets/button_loader.png"></span>
                                <span class="btn-loader__text">{{'BUTTON_LOADER_TEXT' | translate}}</span>
                            </span>
                        </span>
                    </button>
                </form>

            </div>
        </div>
    </div>
</div>
